import React from 'react';
import CardAntecipacaoParcelas from '../CardAntecipacaoParcelas';
import uuid from 'react-uuid';
import { Container } from './styles.js';
function ContainerCardsAntecipacaoParcelas({
  valoresAntecipacaoParcelas,
  tema,
}) {
  const cardsData = [
    {
      isWithoutDiscount: true,
      text: 'Valor total estimado das parcelas a vencer:',
      value: valoresAntecipacaoParcelas?.valorTotalReal,
      tooltipText: `Esse é o valor estimado das parcelas com a adição de juros e correção monetária, 
      caso você faça o pagamento mês a mês até a data final prevista no contrato.`,
    },

    {
      text: 'Valor estimado das parcelas com desconto para antecipação:',
      value: valoresAntecipacaoParcelas?.valorTotalAntecipado,
      tooltipText: `Esse é o valor estimado que você vai pagar,
       caso escolha fazer a antecipação dessas parcelas nesta data.`,
    },

    {
      isWithoutDiscount: true,
      text: 'Valor estimado da última parcela sem desconto:',
      value: valoresAntecipacaoParcelas?.valorRealUltimaParcela,
      tooltipText: `Esse é o valor estimado que você vai pagar 
      na data de vencimento da última parcela com a adição dos juros e correção monetária.`,
    },

    {
      text: 'Valor estimado da última parcela com desconto:',
      value: valoresAntecipacaoParcelas?.valorAntecipadoUltimaParcela,
      tooltipText: `Esse é o valor estimado da última parcela caso faça a antecipação 
      do pagamento nesta data.`,
    },
  ];

  return (
    <Container>
      {cardsData.map((card) => {
        return <CardAntecipacaoParcelas {...card} tema={tema} key={uuid()} />;
      })}
    </Container>
  );
}

export default ContainerCardsAntecipacaoParcelas;
